export default {
  fontFamily: 'Museo Sans',
  useNextVariants: true,
};
